var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { tokens } from '@neo4j-ndl/base';
import { components, } from 'react-select';
import { classNames } from '../_common/defaultImports';
import { ChevronDownIconOutline, ExclamationCircleIconSolid, XMarkIconOutline, } from '../icons';
import { Checkbox } from '../checkbox';
export const DropdownIndicatorCurrying = ({ errorText, size, }) => function Component(props) {
    const { isDisabled, selectProps } = props;
    const classes = classNames('ndl-dropdown-icon', {
        'ndl-small': size === 'small',
        'ndl-medium': size === 'medium',
        'ndl-large': size === 'large',
        'ndl-disabled': isDisabled,
    });
    return (_jsx(components.DropdownIndicator, Object.assign({}, props, { children: _jsxs("div", { className: "n-flex n-flex-row n-gap-token-5", children: [_jsx(ChevronDownIconOutline, { className: classes, style: {
                        transform: selectProps.menuIsOpen
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                        transitionDuration: tokens.transitions.values.duration.quick,
                    } }), errorText && (_jsxs(_Fragment, { children: [_jsx("div", { className: "ndl-indicator" }), _jsx(ExclamationCircleIconSolid, { className: `ndl-error-icon ${classes}`, role: "img", type: "solid" })] }))] }) })));
};
export const CustomClearIndication = ({ errorText, size, }) => function Component(props) {
    return (_jsx(components.ClearIndicator, Object.assign({}, props, { children: _jsxs("div", { className: "n-flex n-flex-row n-gap-token-5", children: [_jsx(XMarkIconOutline, { className: "n-size-5 n-text-palette-neutral-text-weak n-cursor-pointer" }), _jsx("div", { className: "ndl-indicator" })] }) })));
};
export const CustomMultiValueRemove = ({ errorText, size, }) => function Component(props) {
    return (_jsx(components.MultiValueRemove, Object.assign({}, props, { children: _jsx(XMarkIconOutline, { className: "n-text-palette-neutral-text-weak", style: {
                height: size === 'small' ? '16px' : '20px',
            } }) })));
};
export const CustomPlaceholder = ({ errorText, size, }) => function Component(_a) {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    return (_jsx(components.Placeholder, Object.assign({}, restProps, { children: _jsx("div", { className: "ndl-placeholder", children: children }) })));
};
export const CustomOption = ({ errorText, size, hasCheckboxes, }) => function Component(_a) {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    const classes = classNames('ndl-dropdown-option', restProps.className, {
        'n-body-medium': size === 'small' || size === 'medium',
        'n-body-large': size === 'large',
    });
    return (_jsxs(components.Option, Object.assign({}, restProps, { className: classes, children: [hasCheckboxes === true && _jsx(Checkbox, { checked: restProps.isSelected }), children] })));
};
//# sourceMappingURL=Overrides.js.map